var exports = {
  "a": "AvatarUltraReveal.module__box___Nmd1U2",
  "S": "AvatarUltraReveal.module__image___Nmd1U2",
};

module.exports = exports;
